import { render, staticRenderFns } from "./ModelManagementPage.vue?vue&type=template&id=49bce843&scoped=true"
import script from "./ModelManagementPage.vue?vue&type=script&lang=js"
export * from "./ModelManagementPage.vue?vue&type=script&lang=js"
import style0 from "./ModelManagementPage.vue?vue&type=style&index=0&id=49bce843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bce843",
  null
  
)

export default component.exports